import React, { Fragment, useState, useEffect } from 'react'
import { Button, FloatingLabel, Form, Toast } from "react-bootstrap"
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'

import { useDispatch, useSelector } from 'react-redux'
import { LoginUser } from '../Redux/UsersDucks'
import Visibility from '@mui/icons-material/Visibility'; // Ícono de ojo
import VisibilityOff from '@mui/icons-material/VisibilityOff'

const LoginPage = () => {
    const { register, handleSubmit } = useForm()
    //para el toast
    const [message,setMessage] = useState("")
    const [messageBody,setMessageBody] = useState("")
    const [showPassword, setShowPassword] = useState(false);
    const [showToast,setShowToast] = useState(false)
    const [bgColor,setBgColor] = useState("info")
    

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const user = useSelector(store => store.users.user)

    const onLogin = (data) => {dispatch(LoginUser(data)) }
    
    useEffect(()=>{
        if(user.message!=null){
            setShowToast(true)
            setMessage(user.message)
        }
        if(user.success){
            setBgColor("success")
            setMessageBody( `${window.message.welcome} ${user.user.nombre}.`)
            setTimeout(() => {
                navigate("/Inicio")
            }, 1000);
        }else{
            setBgColor("info")
        }
    },[navigate, user])

    return (
        <Fragment>
            <section className="vh-100 d-flex align-items-center justify-content-center">
                <div className="card" style={{ borderRadius: "1rem", maxWidth: "900px", width: "100%" }}>
                    <div className="row g-0">
                        <div className="col-md-6 d-none d-md-block">
                            <img src="./img/dc51d465-90e7-44b2-ac4b-a69928b9.png" alt="login form" className="img-fluid" style={{ borderRadius: "1rem 0 0 1rem" }} />
                        </div>
                        <div className="col-md-6 d-flex align-items-center">
                            <div className="card-body p-4 text-black">
                                <Form onSubmit={handleSubmit(onLogin)}>
                                    <div className="d-flex align-items-center mb-3 pb-1">
                                        <span className="w-100 mb-0 d-flex justify-content-center">
                                            <img src="./logo3.png" alt="..." width={180} height={100} />
                                        </span>
                                    </div>
                                    <h5 className="fw-normal mb-3 pb-3 text-center" style={{ letterSpacing: "1px" }}>Inicie sesión en su cuenta</h5>
                                    <FloatingLabel label="Usuario" className="mb-4">
                                        <Form.Control type="text" placeholder="Usuario" {...register('email', { required: "Cuenta de usuario es obligatorio" })} />
                                    </FloatingLabel>
                                    <div className="input-group mb-3">
                                        <FloatingLabel label="Contraseña" className="flex-grow-1">
                                            <Form.Control
                                                type={showPassword ? 'text' : 'password'}
                                                placeholder="Contraseña"
                                                {...register('password', { required: "Contraseña es obligatorio" })}
                                            />
                                        </FloatingLabel>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="btn-toggle-password"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </Button>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <Button type="submit" className="btn btn-primary btn-lg">Ingresar</Button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Toast show={showToast} onClose={() => setShowToast(false)} bg={bgColor} className="position-fixed top-0 end-0 mt-3 me-3" style={{ zIndex: "10000" }} delay={4000} autohide>
                <Toast.Header>
                    <strong className="me-auto">{message}</strong>
                </Toast.Header>
                <Toast.Body>{messageBody}</Toast.Body>
            </Toast>
        </Fragment>
    );
}
export default LoginPage;